export const DIUploadTypes = {
  FileUploadDispatcher: Symbol('FileUploadDispatcher'),
  FileUploadDispatcherFactory: Symbol('FileUploadDispatcherFactory'),
  MultipartFileUploadDispatcher: Symbol('MultipartFileUploadDispatcher'),
  MultipartFileUploadDispatcherFactory: Symbol('MultipartFileUploadDispatcherFactory'),
  FormDataFileUploadDispatcher: Symbol('FormDataFileUploadDispatcher'),
  FormDataFileUploadDispatcherFactory: Symbol('FormDataFileUploadDispatcherFactory'),
  BulkQuestionUploadDispatcher: Symbol('BulkQuestionUploadDispatcher'),
  BulkQuestionUploadDispatcherFactory: Symbol('BulkQuestionUploadDispatcherFactory'),
  UsersUploadDispatcher: Symbol('UsersUploadDispatcher'),
  UsersUploadDispatcherFactory: Symbol('UsersUploadDispatcherFactory'),
  SocketProcessingAdapterFactory: Symbol('SocketProcessingAdapterFactory'),
  SocketProcessingAdapter: Symbol('SocketProcessingAdapter'),
};
